import { selectBonuses } from "@/entities/bonus"
import { useAppSelector } from "@/shared/lib/redux"
import { selectAggregates } from "../../model"
import { useMemo } from "react"
import { ChartBlock } from "@/shared/ui/chart-block"

export const CountTransactions = () => {
    const bonuses = useAppSelector(selectBonuses)
    const aggregates = useAppSelector(selectAggregates)

    const data = useMemo(() => {
        const parsed = bonuses
            .map((bonus) => ({
                bonus: bonus,
                data: aggregates.bonuses[bonus.id]?.count
            }))
            .filter((exists) => exists.data ?? 0)
        const labels = parsed.map(obj => obj.bonus.name)
        const data = parsed.map(obj => obj.data)
        return {
            labels,
            datasets: [{
                data
            }]
        }
            
    }, [bonuses, aggregates])

    return (
        <ChartBlock chartClass="min-h-[350px] h-full" type="doughnut" title="Количество транзакций по бонусам" data={data}/>
    )
}